import { useQuery } from '@apollo/client';
import { GrowthBookProject } from '../../../__generated__/loma';
import { usePageContext } from './PageContext/usePageContext';
import isGrowthBookFeatureOn from '../../../graphql/getGrowthbook';

interface UseIsGrowthBookFeatureOnOptions {
  project: GrowthBookProject;
  feature: string;
  attributes: Record<string, string | undefined>;
  anonymousId?: string;
  sourceWriteKey?: string;
}

function useIsGrowthBookFeatureOn({
  feature,
  project,
  attributes,
  anonymousId,
  sourceWriteKey,
}: UseIsGrowthBookFeatureOnOptions) {
  const result = useQuery(isGrowthBookFeatureOn, {
    variables: {
      project,
      feature,
      attributes,
      anonymousId,
      sourceWriteKey,
    },
  });

  const enabled = result.data?.isGrowthBookFeatureOn ?? false;

  return {
    enabled,
    result,
  };
}

function useIsTrackFeatureOn(feature: string) {
  const {
    state: {
      retailerMoniker,
      localeCountry,
      localeLanguage,
      trackingStatus,
      trackingNumbers,
      orderNumbers,
    },
  } = usePageContext();

  const [orderNumber] = orderNumbers ?? [];
  const [trackingNumber] = trackingNumbers ?? [];

  const attributes = {
    track_localeCountry: localeCountry,
    track_localeLanguage: localeLanguage,
    track_orderNumber: orderNumber,
    track_retailerMoniker: retailerMoniker,
    track_shipmentStatus: trackingStatus,
    track_trackingNumber: trackingNumber,
  };

  return useIsGrowthBookFeatureOn({
    project: 'TRACK',
    feature,
    attributes,
    sourceWriteKey: retailerMoniker,
  });
}

export { useIsGrowthBookFeatureOn, useIsTrackFeatureOn };
